import React, { useState, useEffect } from "react";
import styleClasses from "./NewFooter.module.scss";
import { Container, Row, Col } from "react-bootstrap";
import { getUser } from "../../helpers/helperMethods";
import * as CONSTANT from "../../constants";
import useKeypress from "../../hooks/useKeypress";
import PopUpModel from "../../components/Footer/PopUpModel";
import { NavlinkModel } from "../../models/navlink.model";
import { Link } from "react-router-dom";
import GlutenSensitiveModal from "./GlutenSensitiveModal";
import { InstagramIcon, MailIcon, TiktokIcon } from "../../images/svgIcons/svg";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import { useAuthState } from "../../context/UserAuthentication";
import appStoreIcon from "../../images/appStore.png";
import playStoreIcon from "../../images/playStore.png";
import zupasLogo from "../../images/zupas-icon-logo.svg";

// ── Desktop SVG Icons ─────────────────────────────────────────────────────────

const TikTokDtIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#0956A8" d="M19.6 6.8a5.9 5.9 0 0 1-3.5-1.1 5.9 5.9 0 0 1-2.3-3.9h-3.3v13.1a2.9 2.9 0 1 1-2.1-2.8v-3.4a6.2 6.2 0 1 0 5.4 6.2V9.3a9 9 0 0 0 5.8 2v-3.3q-.05 0 0-1.2z" />
  </svg>
);

const InstagramDtIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="5" stroke="#0956A8" strokeWidth="2" />
    <circle cx="12" cy="12" r="4" stroke="#0956A8" strokeWidth="2" />
    <circle cx="17.3" cy="6.7" r="1.2" fill="#0956A8" />
  </svg>
);

const FacebookDtIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#0956A8" d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5H16.5V4.4a20 20 0 0 0-2.3-.1c-2.3 0-3.8 1.4-3.8 3.9v2.2H7.8v3h2.6V21h3.1z" />
  </svg>
);

const EmailDtIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2.2" stroke="#0956A8" strokeWidth="2" />
    <path d="M4 7l7.3 5.3a1.2 1.2 0 0 0 1.4 0L20 7" stroke="#0956A8" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const AppStoreBadge = () => (
  <svg width="162" height="54" viewBox="0 0 180 60" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
    <rect width="180" height="60" rx="10" ry="10" fill="#000" />
    <rect x="0.5" y="0.5" width="179" height="59" rx="9.5" ry="9.5" fill="none" stroke="#A6A6A6" strokeWidth="1" />
    <g transform="translate(16,13)" fill="#fff">
      <path d="M23.2 17.6c0-2.8 2.3-4.2 2.4-4.3-1.3-1.9-3.4-2.2-4.1-2.2-1.7-.2-3.4 1-4.3 1-.9 0-2.2-1-3.7-1-1.9 0-3.6 1.1-4.6 2.8-2 3.4-.5 8.5 1.4 11.3.9 1.4 2.1 2.9 3.5 2.8 1.4-.1 1.9-.9 3.6-.9s2.2.9 3.7.9 2.5-1.4 3.4-2.8c1.1-1.6 1.5-3.2 1.5-3.3-.1 0-2.8-1.1-2.8-4.3zM20.6 9.3c.8-.9 1.3-2.2 1.1-3.5-1.1 0-2.4.7-3.2 1.6-.7.8-1.4 2.1-1.2 3.4 1.2.1 2.5-.6 3.3-1.5z" />
    </g>
    <g transform="translate(52,20)" fill="#fff" fontFamily="Helvetica,Arial,sans-serif">
      <text fontSize="8" letterSpacing="0.3" y="0">Download on the</text>
      <text fontSize="17" fontWeight="600" y="20" letterSpacing="-0.3">App Store</text>
    </g>
  </svg>
);

const GooglePlayBadge = () => (
  <svg width="162" height="54" viewBox="0 0 180 60" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
    <rect width="180" height="60" rx="10" ry="10" fill="#000" />
    <rect x="0.5" y="0.5" width="179" height="59" rx="9.5" ry="9.5" fill="none" stroke="#A6A6A6" strokeWidth="1" />
    <g transform="translate(16,14)">
      <path d="M.5.8c-.3.3-.5.8-.5 1.5v28c0 .7.2 1.2.5 1.5l.1.1 15.7-15.7v-.4L.6.7l-.1.1z" fill="#5BC9F4" />
      <path d="M21.5 22.5L16.3 17.3v-.4l5.2-5.2.1.1 6.2 3.5c1.8 1 1.8 2.7 0 3.7l-6.3 3.5z" fill="#FEE000" />
      <path d="M21.6 22.4l-5.3-5.3L.5 32.9c.6.6 1.6.7 2.7.1l18.4-10.6" fill="#EA4335" />
      <path d="M21.6 11.8L3.2 1.3C2.1.6 1.1.7.5 1.3l15.8 15.8 5.3-5.3z" fill="#34A853" />
    </g>
    <g transform="translate(52,20)" fill="#fff" fontFamily="Helvetica,Arial,sans-serif">
      <text fontSize="8" letterSpacing="0.3" y="0">GET IT ON</text>
      <text fontSize="17" fontWeight="600" y="20" letterSpacing="-0.2">Google Play</text>
    </g>
  </svg>
);

// ── Component ─────────────────────────────────────────────────────────────────

interface footerProps {
  bgColor?: string;
  textColor?: string;
  mt?: boolean;
  footer_img_controller?: string;
  sectionController?: string;
  suppressTopPadding?: boolean;
  hidemurals?: string;
  stickybtn?: string;
}

const NewFooter: React.FunctionComponent<footerProps> = ({
  sectionController,
  suppressTopPadding = false,
}) => {
  useKeypress("Escape", () => {
    setShow(false);
  });
  const isItMobile = useCheckMobileScreen();
  const { authInfo } = useAuthState();
  const [isDeviceIos, setIsDeviceIos] = React.useState(false);
  const [show, setShow] = useState(false);
  const [openGlutenModal, setOpenGlutenModal] = useState(false);
  const user = getUser();
  const userType = user.type ?? "";
  const authUserId = userType !== CONSTANT.GUEST_USER ? authInfo?.userId : null;

  const footerLinks: NavlinkModel[] = [
    { link: CONSTANT.ROUTE_MENU, text: "MENU", alternateURL: { exist: false, link: null } },
    { text: "REWARDS", link: CONSTANT.ROUTE_FAQ, alternateURL: { exist: true, link: CONSTANT.ROUTE_REWARDS_REDEEM } },
    { text: "APP DOWNLOAD", link: "https://onelink.to/emaillinks", alternateURL: { exist: true, link: "https://onelink.to/emaillinks" } },
    { link: CONSTANT.CATERING_PRINT_MENU, text: "CATERING MENU", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.CATERING_LOYALTY_PAGE, text: "CATERING  Rewards", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_NUTRITION, text: "NUTRITIONAL INFO ", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_LOCATIONS, text: "FIND A LOCATION ", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_CAREERS, text: "CAREERS", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_TALK_TO_US, text: "CONTACT US", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.PRIVACY_POLICY_ROUTE, text: "PRIVACY POLICY", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.TERMS_ROUTE, text: "TERMS & CONDITIONS", alternateURL: { exist: false, link: null } },
  ];

  const footerLinksMobile: NavlinkModel[] = [
    { link: CONSTANT.HANDHELD_MENU_PDF, text: "MENU", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_NUTRITION, text: "NUTRITIONAL INFO ", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.CATERING_PRINT_MENU, text: "CATERING MENU", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_LOCATIONS, text: "FIND A RESTAURANT ", alternateURL: { exist: false, link: null } },
    { text: "REWARDS", link: CONSTANT.ROUTE_FAQ, alternateURL: { exist: true, link: CONSTANT.ROUTE_REWARDS_REDEEM } },
    { link: CONSTANT.ROUTE_CAREERS, text: "CAREERS", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.CATERING_LOYALTY_PAGE, text: "CATERING  Rewards", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.ROUTE_TALK_TO_US, text: "CONTACT US", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.PRIVACY_POLICY_ROUTE, text: "PRIVACY POLICY", alternateURL: { exist: false, link: null } },
    { link: CONSTANT.TERMS_ROUTE, text: "TERMS & CONDITIONS", alternateURL: { exist: false, link: null } },
  ];

  const socialIconsArray = [
    { link: CONSTANT.CAFEZUPAS_TIKTOK_URL, icon: <TiktokIcon />, socail_alt_text: `tiktok` },
    { link: `${CONSTANT.CAFEZUPAS_INSTAGRAM_URL}cafezupas/`, icon: <InstagramIcon />, socail_alt_text: `instargram` },
  ];

  const [moboImages, setmoboImages] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleClick = () => setShow(true);

  const loyaltyRedirectionLink = (item) => {
    return userType === CONSTANT.GUEST_USER || user?.logged_out
      ? item.link
      : item.alternateURL.exist
      ? item.alternateURL.link
      : item.link;
  };

  useEffect(() => {
    let isMounted = true;
    var userAgent = navigator.userAgent || navigator.vendor;
    var x = window.matchMedia("(min-width: 768px)");
    if (x.matches) { setmoboImages(true); } else { setmoboImages(false); }
    if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
      setIsDeviceIos(true);
    } else {
      setIsDeviceIos(false);
    }
    return () => { isMounted = false; };
  }, []);

  return (
    <div className={`${sectionController} ${suppressTopPadding ? "" : " pt-md-5"}`}>
      <div className={styleClasses.footerWrapper}>
        
        {!isItMobile ? (
          /* ── DESKTOP FOOTER ── */
          <footer className={styleClasses.desktopFooter}>
            <div className={styleClasses.footerBand}>

              {/* Top: App Download + Find Location */}
              <div className={styleClasses.topGrid}>

                {/* Left: App download */}
                <div>
                  <div className={`${styleClasses.eyebrow} font-helvetica-black-extended`}>Order Faster</div>
                  <h3 className={`${styleClasses.heading} font-helvetica-black-extended-oblique`}>
                    Order faster in the app.
                  </h3>
                  <p className={`${styleClasses.bodyText} font-helvetica-light`}>
                    Reorder favorites in two taps. Earn points <br/>  automatically. Skip the line.
                  </p>
                  <div className={styleClasses.badgeRow}>
                    <a
                      href="https://apps.apple.com/pk/app/caf%C3%A9-zupas-loyalty/id6448428217"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Download on the App Store"
                      className={styleClasses.badgeLink}
                    >
                      <AppStoreBadge />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.cafezupasres.co&hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Get it on Google Play"
                      className={styleClasses.badgeLink}
                    >
                      <GooglePlayBadge />
                    </a>
                  </div>
                </div>

                {/* Right: Find a location */}
                <div>
                  <div className={`${styleClasses.eyebrow} font-helvetica-black-extended`}>Find Us</div>
                  <h3 className={`${styleClasses.heading} font-helvetica-black-extended-oblique`}>
                    80+ locations, and <br/>growing.
                  </h3>
                  <p className={`${styleClasses.bodyText} font-helvetica-light`}>
                    Open kitchens from Utah to Minnesota. There's <br/> probably one closer than you think.
                  </p>
                  <Link
                    to={CONSTANT.ROUTE_LOCATIONS}
                    className={`${styleClasses.findBtn} font-helvetica-black-extended `}
                  >
                    Find a Location › 
                  </Link>
                </div>
              </div>

              {/* Nav Grid: Logo + 3 columns */}
              <div className={styleClasses.bottomGrid}>

                {/* Logo + Tagline */}
                <div>
                  <img
                    src={zupasLogo}
                    alt="Cafe Zupas"
                    className={styleClasses.logoImg}
                  />
                  <div className={`${styleClasses.tagline} font-ticketing`}>
                    Find the Good Life <br/> Everywhere.
                  </div>
                </div>

                {/* Order */}
                <div>
                  <div className={`${styleClasses.colHeader} font-helvetica-black-extended`}>Order</div>
                  <div className={`${styleClasses.linkList} font-helvetica-light`}>
                    <a href={CONSTANT.HANDHELD_MENU_PDF} target="_blank" rel="noopener noreferrer">Menu</a>
                    <Link to={loyaltyRedirectionLink(footerLinks[1])}>Rewards</Link>
                    <a href={CONSTANT.CATERING_LOYALTY_PAGE}>Catering</a>
                    <a href={CONSTANT.ROUTE_NUTRITION} target="_blank" rel="noopener noreferrer">
                      Nutritional Info
                    </a>
                    <button onClick={() => setOpenGlutenModal(true)}>
                      Allergens &amp; Dietary
                    </button>
                  </div>
                </div>

                {/* Company */}
                <div>
                  <div className={`${styleClasses.colHeader} font-helvetica-black-extended`}>Company</div>
                  <div className={`${styleClasses.linkList} font-helvetica-light`}>
                    <Link to={CONSTANT.ROUTE_OUR_KITCHEN}>Our Kitchen</Link>
                    <Link to={CONSTANT.ROUTE_CAREERS}>Careers</Link>
                    <Link to={CONSTANT.ROUTE_FUNDRAISING}>Fundraisers</Link>
                    <Link to={CONSTANT.ROUTE_TALK_TO_US}>Contact Us</Link>
                  </div>
                </div>

                {/* Legal */}
                <div>
                  <div className={`${styleClasses.colHeader} font-helvetica-black-extended`}>Legal</div>
                  <div className={`${styleClasses.linkList} font-helvetica-light`}>
                    <Link to={CONSTANT.PRIVACY_POLICY_ROUTE}>Privacy Policy</Link>
                    <Link to={CONSTANT.TERMS_ROUTE}>Terms &amp; Conditions</Link>
                  </div>
                </div>
              </div>

              {/* Bottom Bar: Social + Legal */}
              <div className={styleClasses.bottomBar}>
                <div className={styleClasses.socialRow}>
                  {[
                    { title: "TikTok",    href: CONSTANT.CAFEZUPAS_TIKTOK_URL,                         Icon: TikTokDtIcon,    external: true,  onClick: undefined },
                    { title: "Instagram", href: `${CONSTANT.CAFEZUPAS_INSTAGRAM_URL}cafezupas/`,        Icon: InstagramDtIcon, external: true,  onClick: undefined },
                    { title: "Facebook",  href: `${CONSTANT.CAFEZUPAS_FACEBOOK_URL}cafezupas/`,                        Icon: FacebookDtIcon,  external: true,  onClick: undefined },
                    { title: "Email",     href: "#",                                                     Icon: EmailDtIcon,     external: false, onClick: handleClick },
                  ].map(({ title, href, Icon, external, onClick }) => (
                    <a
                      key={title}
                      href={href}
                      title={title}
                      onClick={onClick}
                      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                      className={styleClasses.socialIcon}
                    >
                      <Icon />
                    </a>
                  ))}
                </div>

                <div className={`${styleClasses.legalText} font-helvetica-light`}>
                  <Link to={CONSTANT.PRIVACY_POLICY_ROUTE}>Privacy</Link>
                  {" · "}
                  <Link to={CONSTANT.TERMS_ROUTE}>Terms</Link>
                </div>
              </div>

            </div>
          </footer>
        ) : (
          /* ── MOBILE FOOTER (original, unchanged) ── */
          <Container fluid className="cz-px-24">
            <Row className="align-items-start">
              <div>
                <ul className={`${styleClasses.socialIcons} ps-0`}>
                  <li>
                    <a onClick={handleClick}>
                      {" "}
                      <MailIcon />{" "}
                    </a>
                  </li>
                  {socialIconsArray.map((icon) => {
                    return (
                      <li>
                        <a href={icon.link}> {icon.icon} </a>
                      </li>
                    );
                  })}
                </ul>

                <h5 className={`${styleClasses.footerTitle} font-ticketing`}>
                  find the good <br /> life everywhere{" "}
                </h5>
                <div className="cz-pt-30 cz-pb-40">
                  <h6 className="font-ticketing f-s25 f-w3 mb-4 ls-05" style={{ color: "#F3F1E9" }}>
                    DOWNLOAD THE APP{" "}
                  </h6>
                  <div className="d-flex align-items-center gap-2 justify-content-center mt-3">
                    <a
                      href="https://apps.apple.com/pk/app/caf%C3%A9-zupas-loyalty/id6448428217"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={appStoreIcon} width={150} alt="app store icon" />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.cafezupasres.co&hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={playStoreIcon} width={150} alt="play store icon" />
                    </a>
                  </div>
                </div>

                <ul className={`${styleClasses.footerLinks} row ps-0 cz-pt-30`}>
                  {footerLinksMobile.map((link, index: number) => {
                    return (
                      <li key={`${link.link}${index}`} className="col-6">
                        {" "}
                        {link.link === CONSTANT.ROUTE_NUTRITION_MENU ||
                        link.link === CONSTANT.CATERING_PRINT_MENU ||
                        link.link === CONSTANT.HANDHELD_MENU_PDF ? (
                          <a
                            href={link.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-helvetica-light"
                          >
                            {link.text}
                          </a>
                        ) : link.link === CONSTANT.CATERING_LOYALTY_PAGE ? (
                          <a href={link.link} className="font-helvetica-light">
                            {link.text}
                          </a>
                        ) : (
                          <Link to={"" + loyaltyRedirectionLink(link)} className="font-helvetica-light">
                            {link.text}
                          </Link>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Row>
          </Container>
        )}
      </div>

      <Row>
        <Col xs="12" sm="12" md="6">
          <PopUpModel showPopup={show} closePopup={handleClose} />
        </Col>
        <GlutenSensitiveModal
          openGlutenModal={openGlutenModal}
          setOpenGlutenModal={setOpenGlutenModal}
        />
      </Row>
    </div>
  );
};

export default NewFooter;
